import { render, staticRenderFns } from "./colStock.vue?vue&type=template&id=1dd48156&"
import script from "./colStock.vue?vue&type=script&lang=js&"
export * from "./colStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports